import React from "react";

// Css
import classes from "./NotificationItem.module.css";

// Img
import notiImg from "../../../../assets/png/event-banner.png";

// Mui
import { Box } from "@mui/material";

// Jds
import { Avatar, Card, Container, ListBlock, Text } from "@jds/core";
import { baseToImg } from "../../../../util/helper";

const NotificationDot = (props) => {
  return <Box className={classes["notification__dot"]} {...props}></Box>;
};

export default function NotificationItem(props) {
  const { data } = props;
  const read = data?.isRead || false;
  return (
    <Box
      p={"8px  16px"}
      borderRadius={6}
      bgcolor={!read && "white"}
      sx={{ cursor: "pointer", width: "100%" }}
      onClick={props.onClick}
    >
      <Container fullWidth verticalAlign="center">
        <NotificationDot />
        <ListBlock
          prefix={
            <Avatar
              kind="image"
              size="x-large"
              // image={baseToImg(data?.image) || notiImg}
              image={notiImg}
            />
          }
          titleBlock={{
            text: (
              <Text
                text={data?.title || "this is a notification"}
                appearance="body-s-bold"
              />
            ),
          }}
          helperBlock={{
            text: (
              <Text
                text={data?.description || ""}
                appearance="body-xs"
                color="primary-grey-80"
              />
            ),
          }}
        />
      </Container>
    </Box>
  );
}
